import React, { useEffect, useRef, useState } from "react";
import "../styles/DropdownSystem.css";

export default function StyledSelect({
  value,
  options,
  onChange,
  className = "",
  minWidth = 160,
  ariaLabel = "Select option",
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!wrapperRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleOutsideClick);
    return () => document.removeEventListener("pointerdown", handleOutsideClick);
  }, []);

  const selected = options.find((option) => String(option.value) === String(value));

  return (
    <div
      ref={wrapperRef}
      className={`nw-styled-select ${className}`.trim()}
      style={{ minWidth }}
    >
      <button
        type="button"
        className={`nw-styled-select-toggle ${open ? "open" : ""}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={ariaLabel}
        onClick={() => setOpen((current) => !current)}
      >
        <span>{selected?.label || "Select"}</span>
        <i className="fa-solid fa-chevron-down" aria-hidden="true" />
      </button>

      {open && (
        <div className="nw-styled-select-menu" role="listbox">
          {options.map((option) => {
            const active = String(option.value) === String(value);
            return (
              <button
                key={option.value}
                type="button"
                className={`nw-styled-select-option ${active ? "active" : ""}`}
                role="option"
                aria-selected={active}
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
